import React, { useState, useEffect } from "react";
import api from "../common/api";
import axios from "axios";
import {
  Button,
  CircularProgress,
  Snackbar,
  TextField,
  Typography
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { Autocomplete } from "@material-ui/lab";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const SAPProject = ({ id }) => {
  const [project, setProject] = useState({ client: {} });
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    severity: ""
  });
  const [clientsAutocomplete, setClientsAutocomplete] = useState({
    options: [],
    loading: false
  });
  const handleClientSearch = async (search, callback) => {
    var value = callback;
    const token = localStorage.getItem("userToken");
    if (value.length > 2) {
      return axios
        .get(api.clients().autocomplete(value), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setClientsAutocomplete({
            options: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const getProject = async id => {
    let url = api.sapProjects().get(id);
    const token = localStorage.getItem("userToken");
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProject(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (id > 0) getProject(id);
  }, [id]);

  const handleSubmit = () => {
    setSaving(true);
    const formData = new FormData();
    formData.append("name", project.name ? project.name : "");
    formData.append("code", project.code ? project.code : "");
    formData.append(
      "description",
      project.description ? project.description : ""
    );
    formData.append("start_date", project.start_date ? project.start_date : "");
    formData.append("end_date", project.end_date ? project.end_date : "");
    formData.append("client_id", project.client_id ? project.client_id : "");
    const token = localStorage.getItem("userToken");
    let url = api.sapProjects().post();
    axios

      .post(url, formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setToast({
          open: true,
          message: "Proyecto guardado con éxito",
          severity: "success"
        });
        if (!id)
          setProject({
            name: "",
            code: "",
            description: "",
            start_date: "",
            end_date: "",
            client_id: ""
          });
        setSaving(false);
      })
      .catch(err => {
        setSaving(false);
        setToast({
          open: true,
          message: "Ha ocurrido un error al guardar el proyecto",
          severity: "error"
        });
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <Typography variant="h6">
            {id > 0 ? "Editar Proyecto" : "Nuevo Proyecto"}
          </Typography>
        </div>
        <div className="col-md-3">
          <TextField
            id="name"
            name="name"
            label="Nombre"
            type="text"
            required
            placeholder="Ingrese el nombre del proyecto"
            onChange={e => setProject({ ...project, name: e.target.value })}
            value={project.name}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-3">
          <TextField
            id="code"
            name="code"
            label="Código"
            type="text"
            required
            placeholder="Ingrese el código del proyecto"
            onChange={e => setProject({ ...project, code: e.target.value })}
            value={project.code}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-6">
          <TextField
            id="description"
            name="description"
            label="Descripción"
            type="text"
            placeholder="Ingrese la descripción del proyecto"
            onChange={e =>
              setProject({ ...project, description: e.target.value })
            }
            value={project.description}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-3">
          <TextField
            id="start_date"
            name="start_date"
            label="Fecha de Inicio"
            type="date"
            required
            onChange={e =>
              setProject({ ...project, start_date: e.target.value })
            }
            value={project.start_date}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-3">
          <TextField
            id="end_date"
            name="end_date"
            label="Fecha de Fin"
            type="date"
            onChange={e => setProject({ ...project, end_date: e.target.value })}
            value={project.end_date}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-3">
          {id == 0 ? (
            <Autocomplete
              id={"clients"}
              name={"clients"}
              getOptionLabel={option => option.business_name}
              getOptionSelected={(option, value) =>
                option.business_name === value
              }
              renderOption={option => (
                <Typography variant="caption">
                  {option.business_name}
                </Typography>
              )}
              options={clientsAutocomplete.options}
              loading={clientsAutocomplete.loading}
              onInputChange={handleClientSearch}
              onChange={(e, value) => {
                if (value) {
                  setProject({
                    ...project,
                    client_id: value.id
                  });
                }
              }}
              autoComplete
              noOptionsText={
                <Typography variant="caption">Sin resultados</Typography>
              }
              includeInputInList
              className="mt-2 px-0"
              renderInput={params => (
                <TextField
                  {...params}
                  placeholder="Ingrese un cliente"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {clientsAutocomplete.loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    shrink: true
                  }}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: "0.75rem", width: 230 }
                  }}
                />
              )}
            />
          ) : (
            <TextField
              id="client_id"
              name="client_id"
              value={project.client.business_name}
              disabled
              margin="normal"
              className="mr-2 "
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
            />
          )}
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-3">
          <Button
            disabled={saving}
            variant="contained"
            color="primary"
            onClick={e => {
              handleSubmit(e);
            }}
          >
            Guardar
          </Button>
        </div>
        <Snackbar
          open={toast.open}
          onClose={() => setToast({ ...toast, open: false })}
          className="alert-fix"
        >
          <Alert
            onClose={() => setToast({ ...toast, open: false })}
            severity={toast.severity}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default SAPProject;
